"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTeamCardsStore = void 0;
var vuex_1 = require("vuex");
var vue_1 = require("vue");
var pinia_1 = require("pinia");
var apis_1 = require("@/constants/apis");
console.log("Initializing Pinia");
var axios_1 = require("axios");
var userApi_1 = require("@/api/userApi");
var privilegesApi_1 = require("@/api/privilegesApi");
var messagingSender_1 = require("@/utils/messagingSender");
// Generate avatar color from name
function generateAvatarColor(name) {
    var colors = [
        '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
        '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1'
    ];
    var hash = 0;
    for (var i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
}
exports.useTeamCardsStore = (0, pinia_1.defineStore)('teamCards', function () {
    console.log("TeamCard Store Initialized");
    // Vuex store access MUST happen at runtime (inside this function), not at module import
    var vuex = (0, vuex_1.useStore)();
    var allData = (0, vue_1.computed)(function () {
        // guard in case vuex or getters are missing during early startup
        return vuex && vuex.getters ? vuex.getters['login/getAllData'] : { manager: {}, patient: {} };
    });
    var staffContext = (0, vue_1.computed)(function () {
        var _a = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(allData.value), accountnumber = _a.accountnumber, unique_ID = _a.unique_ID;
        return { externId: unique_ID, externId2: accountnumber };
    });
    //IN this instance the current Provider could be the Provider themself | so if they select their own card - could create an Edge Case
    var currentProvider = (0, vue_1.ref)({
        id: 'prov-001',
        name: 'Dr. Sarah Mitchell',
        email: 'dr.mitchell@clinic.com',
        phone: '(555) 123-4567',
        specialty: 'Internal Medicine'
    });
    var patteam = (0, vue_1.ref)([]);
    // Raw flattened members (pre-TeamMember-mapping, still carrying
    // firstname/lastname/member_unique_ID/npinumber) - kept around because
    // SearchContacts.vue's "Add Group" member picker needs this exact shape.
    var rawTeam = (0, vue_1.ref)([]);
    var searchQuery = (0, vue_1.ref)('');
    var filterTag = (0, vue_1.ref)(null);
    var sortBy = (0, vue_1.ref)('Firstname');
    // Get all unique tags
    var allTags = (0, vue_1.computed)(function () {
        var tags = new Set();
        patteam.value.forEach(function (p) { return (p.tags || []).forEach(function (t) { return tags.add(t); }); });
        return Array.from(tags).sort();
    });
    // Filtered and sorted team members
    var filteredProviders = (0, vue_1.computed)(function () {
        var result = __spreadArray([], patteam.value, true);
        // Search filter
        if (searchQuery.value.trim()) {
            var query_1 = searchQuery.value.toLowerCase();
            result = result.filter(function (p) {
                return (p.firstName || '').toLowerCase().includes(query_1) ||
                    (p.lastName || '').toLowerCase().includes(query_1) ||
                    (p.email || '').toLowerCase().includes(query_1) ||
                    (p.phone || '').includes(query_1) ||
                    (p.arn || '').toLowerCase().includes(query_1);
            });
        }
        // Tag filter
        if (filterTag.value) {
            result = result.filter(function (p) { return (p.tags || []).includes(filterTag.value); });
        }
        // Sort
        result.sort(function (a, b) {
            if (sortBy.value === 'Firstname') {
                return "".concat(a.lastName, " ").concat(a.firstName).localeCompare("".concat(b.lastName, " ").concat(b.firstName));
            }
            else if (sortBy.value === 'Lastname') {
                return (b.npinumber || '').localeCompare(a.lastName || '');
            }
            else {
                return (a.status || 'z').localeCompare(b.npinumber || 'z');
            }
        });
        return result;
    });
    function updateProviders(id, updates) {
        var index = patteam.value.findIndex(function (p) { return p.id === id; });
        if (index !== -1) {
            patteam.value[index] = __assign(__assign({}, patteam.value[index]), updates);
        }
    }
    function getProviderById(id) {
        return patteam.value.find(function (p) { return p.id === id; });
    }
    function setSearchQuery(query) {
        searchQuery.value = query;
    }
    function setFilterTag(tag) {
        filterTag.value = tag;
    }
    function setSortBy(sort) {
        sortBy.value = sort;
    }
    //Axios Update Patients | Don't forget to Export this function for access
    function axiosUpdateTeam(id, updates) {
        return __awaiter(this, void 0, void 0, function () {
            var index, providerId, content;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        index = patteam.value.findIndex(function (p) { return p.id === id; });
                        if (!(index !== -1)) return [3 /*break*/, 2];
                        //Axios Call here
                        console.log("Store Updae Object - Dig In and Check It Out");
                        console.log(updates);
                        providerId = id;
                        content = {
                            Provider: {
                                API_Meth: "UpdatePatientProvidersGroupAccountUser",
                                accountnumber: allData.value.manager.externid2,
                                patient_unique_ID: allData.value.patient.externId,
                                member_unique_ID: providerId,
                                firstname: updates.firstName,
                                lastname: updates.lastName,
                                address: (_a = updates.address) === null || _a === void 0 ? void 0 : _a.street, //address1,
                                city: (_b = updates.address) === null || _b === void 0 ? void 0 : _b.city,
                                state: (_c = updates.address) === null || _c === void 0 ? void 0 : _c.state,
                                zip: (_d = updates.address) === null || _d === void 0 ? void 0 : _d.zip,
                                phone: updates.phone,
                                cell: updates.mobile,
                                email: updates.email,
                                npinumber: updates.npinumber,
                            },
                        };
                        return [4 /*yield*/, axios_1.default
                                .post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })
                                .then(function (res) {
                                console.log("Update Providers Return Payload - Debugging");
                                console.log(res.data);
                                var jdata = res;
                                console.log(jdata);
                                if (jdata.data.msg == "Updated") {
                                    alert("Provider" +
                                        " " +
                                        updates.firstName +
                                        " " +
                                        updates.lastName +
                                        " Successfully Updated");
                                }
                                else if (jdata.data.errors) {
                                    console.log("Issue");
                                    console.log(jdata.data.errors.ErrorMessage);
                                }
                            })];
                    case 1:
                        _e.sent();
                        _e.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }
    // ---------------------------------------------------------------------
    // Ported from SearchContacts.vue - flattens groups/contacts/providers/
    // nurses into one "My Team" list. See that file's git history for the
    // original inline implementation this was moved out of.
    // ---------------------------------------------------------------------
    /** Some API_Meth responses come back wrapped in a single top-level key
     * (e.g. {Messages: {...}}) and some come back flat - normalize both. */
    function normalizeApiPayload(data) {
        if (!data || typeof data !== "object")
            return {};
        if (Object.prototype.hasOwnProperty.call(data, "status") || Object.prototype.hasOwnProperty.call(data, "data")) {
            return data;
        }
        var keys = Object.keys(data);
        if (keys.length === 1 && data[keys[0]] && typeof data[keys[0]] === "object") {
            return data[keys[0]];
        }
        return data;
    }
    function fetchProviderDirectory(patientId, accountNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var content, res, list, byEmail_1, bySub_1, byNpi_1, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        content = {
                            Provider: {
                                API_Meth: "GetAllProviders",
                                patientid: patientId,
                                // Required server-side: GetAllClientProvider -> GetProviderUsersFromPatientProvidersGroup
                                // returns an empty set immediately when accountnumber is blank, which silently
                                // made every provider team card fall back to bare email/group with nothing else.
                                accountnumber: accountNumber,
                            },
                        };
                        return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })];
                    case 1:
                        res = _b.sent();
                        list = Array.isArray((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.provider) ? res.data.provider : [];
                        byEmail_1 = new Map();
                        bySub_1 = new Map();
                        byNpi_1 = new Map();
                        list.forEach(function (p) {
                            var emailKey = String((p === null || p === void 0 ? void 0 : p.email) || "").trim().toLowerCase();
                            if (emailKey)
                                byEmail_1.set(emailKey, p);
                            // `id` (= account_user.unique_ID) is what GetProviderUsersFromPatientProvidersGroup
                            // actually returns as the identity column - matches the messaging group's
                            // member.unique_ID directly. subaccountnumber/providerid are kept as fallbacks
                            // for other callers of this same directory shape.
                            var subKey = String((p === null || p === void 0 ? void 0 : p.subaccountnumber) || (p === null || p === void 0 ? void 0 : p.subAccountNumber) || (p === null || p === void 0 ? void 0 : p.providerid) || (p === null || p === void 0 ? void 0 : p.id) || "").trim();
                            if (subKey)
                                bySub_1.set(subKey, p);
                            var npiKey = String((p === null || p === void 0 ? void 0 : p.npinumber) || "").trim();
                            if (npiKey)
                                byNpi_1.set(npiKey, p);
                        });
                        return [2 /*return*/, { byEmail: byEmail_1, bySub: bySub_1, byNpi: byNpi_1, list: list }];
                    case 2:
                        e_1 = _b.sent();
                        console.error("fetchProviderDirectory failed:", e_1);
                        return [2 /*return*/, { byEmail: new Map(), bySub: new Map(), byNpi: new Map(), list: [] }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function fetchNurseDirectory(accountNumber, patientId) {
        return __awaiter(this, void 0, void 0, function () {
            var content, res, rawList, list, byEmail_2, bySub_2, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        content = {
                            NursyInfo: {
                                API_Meth: "GetPatientNurse",
                                accountnumber: accountNumber,
                                patientnumber: patientId,
                            },
                        };
                        return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })];
                    case 1:
                        res = _a.sent();
                        rawList = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
                        list = rawList.map(function (n) { return (__assign(__assign({}, n), { nurseid: n.nurseid || n.nurseId || n.id || n.providerID || n.providerid || n.subaccountnumber || null, licensetype: n.licensetype || n.licenseType || n.license_type || "", 
                            // RNs use `licensenum`, Home Health Aids use `certificatenumber` -
                            // same physical nurses-table role, different label depending on
                            // caregivetype. Fall back between them so either populates the card.
                            licensenum: n.licensenum || n.certificatenumber || n.licenseNumber || n.license_number || "", licenseexpdate: n.licenseexpdate || n.licenseExpiry || n.license_expiry || "", address: n.address || n.addr1 || n.address1 || "", city: n.city || "", state: n.state || "", zip: n.zip || n.postalcode || n.postalCode || "", primaryphone: n.primaryphone || n.primaryPhone || n.tel || n.phone || "", cell: n.cell || n.secondaryphone || n.mobile || "", caregivetype: n.caregivetype || n.caregiverType || "", firstname: n.firstname || n.firstName || "", lastname: n.lastname || n.lastName || "", email: n.email || "" })); });
                        byEmail_2 = new Map();
                        bySub_2 = new Map();
                        list.forEach(function (n) {
                            var emailKey = String((n === null || n === void 0 ? void 0 : n.email) || "").trim().toLowerCase();
                            if (emailKey)
                                byEmail_2.set(emailKey, n);
                            var subKey = String((n === null || n === void 0 ? void 0 : n.providerID) || (n === null || n === void 0 ? void 0 : n.providerid) || (n === null || n === void 0 ? void 0 : n.subaccountnumber) || "").trim();
                            if (subKey)
                                bySub_2.set(subKey, n);
                        });
                        return [2 /*return*/, { byEmail: byEmail_2, bySub: bySub_2 }];
                    case 2:
                        e_2 = _a.sent();
                        console.error("fetchNurseDirectory failed:", e_2);
                        return [2 /*return*/, { byEmail: new Map(), bySub: new Map() }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    /** Allied Professionals are a third clinical-staff category (union of
     * `providers` and `nurses` rows filtered by professionType) that neither
     * the provider directory (account_type IN provider/physicians) nor the
     * nurse directory (Nurses/Home Health Aids groups) ever covered - so
     * Allied Professional team members previously fell back to bare
     * email/group with nothing else. */
    function fetchAlliedDirectory(accountNumber) {
        return __awaiter(this, void 0, void 0, function () {
            var content, res, rawList, list, byEmail_3, bySub_3, e_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        content = {
                            Provider: {
                                API_Meth: "GetAlliedProfessionalByAccountID",
                                accountnumber: accountNumber,
                            },
                        };
                        return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })];
                    case 1:
                        res = _b.sent();
                        rawList = Array.isArray((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.providers) ? res.data.providers : [];
                        list = rawList.map(function (p) { return (__assign(__assign({}, p), { npinumber: p.npi || p.npinumber || "", tel: p.phone || p.tel || "", cell: p.cell || "", addr1: p.addr1 || "", licensetype: p.licenseType || p.licensetype || "", licensenum: p.certificatenumber || p.licensenum || "" })); });
                        byEmail_3 = new Map();
                        bySub_3 = new Map();
                        list.forEach(function (p) {
                            var emailKey = String((p === null || p === void 0 ? void 0 : p.email) || "").trim().toLowerCase();
                            if (emailKey)
                                byEmail_3.set(emailKey, p);
                            var subKey = String((p === null || p === void 0 ? void 0 : p.subaccountnumber) || (p === null || p === void 0 ? void 0 : p.id) || "").trim();
                            if (subKey)
                                bySub_3.set(subKey, p);
                        });
                        return [2 /*return*/, { byEmail: byEmail_3, bySub: bySub_3 }];
                    case 2:
                        e_3 = _b.sent();
                        console.error("fetchAlliedDirectory failed:", e_3);
                        return [2 /*return*/, { byEmail: new Map(), bySub: new Map() }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function fetchStrictlyAssignedProviders(accountNumber, patientId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, accountProvidersRes, patientAssignedRes, accountProviders, patientAssigned, assignedIds_1, e_4;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all([
                                axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", {
                                    Provider: {
                                        API_Meth: "GetAccountProviders",
                                        accountnumber: accountNumber,
                                    },
                                }, { headers: { "Content-Type": "application/json;" } }),
                                axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", {
                                    Provider: {
                                        API_Meth: "GetAllProviders",
                                        patientid: patientId,
                                        accountnumber: accountNumber,
                                    },
                                }, { headers: { "Content-Type": "application/json;" } }),
                            ])];
                    case 1:
                        _a = _d.sent(), accountProvidersRes = _a[0], patientAssignedRes = _a[1];
                        accountProviders = Array.isArray((_b = accountProvidersRes === null || accountProvidersRes === void 0 ? void 0 : accountProvidersRes.data) === null || _b === void 0 ? void 0 : _b.provider)
                            ? accountProvidersRes.data.provider
                            : [];
                        patientAssigned = Array.isArray((_c = patientAssignedRes === null || patientAssignedRes === void 0 ? void 0 : patientAssignedRes.data) === null || _c === void 0 ? void 0 : _c.provider)
                            ? patientAssignedRes.data.provider
                            : [];
                        assignedIds_1 = new Set(patientAssigned
                            .map(function (p) { return String((p === null || p === void 0 ? void 0 : p.subaccountnumber) || (p === null || p === void 0 ? void 0 : p.subAccountNumber) || (p === null || p === void 0 ? void 0 : p.providerid) || (p === null || p === void 0 ? void 0 : p.npinumber) || "").trim(); })
                            .filter(Boolean));
                        return [2 /*return*/, accountProviders.filter(function (p) {
                                var id = String((p === null || p === void 0 ? void 0 : p.subaccountnumber) || (p === null || p === void 0 ? void 0 : p.subAccountNumber) || (p === null || p === void 0 ? void 0 : p.providerid) || (p === null || p === void 0 ? void 0 : p.npinumber) || "").trim();
                                return id && assignedIds_1.has(id);
                            })];
                    case 2:
                        e_4 = _d.sent();
                        console.error("fetchStrictlyAssignedProviders failed:", e_4);
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function flattenTeamMembers(groups, legacyContacts, providerDirectory, nurseDirectory, alliedDirectory) {
        if (legacyContacts === void 0) { legacyContacts = []; }
        var byEmail = new Map();
        var byName = new Map();
        (Array.isArray(legacyContacts) ? legacyContacts : []).forEach(function (c) {
            var emailKey = String((c === null || c === void 0 ? void 0 : c.email) || "").trim().toLowerCase();
            if (emailKey && !byEmail.has(emailKey))
                byEmail.set(emailKey, c);
            var nameKey = "".concat(String((c === null || c === void 0 ? void 0 : c.firstName) || "").trim().toLowerCase(), "|").concat(String((c === null || c === void 0 ? void 0 : c.lastName) || "").trim().toLowerCase());
            if (((c === null || c === void 0 ? void 0 : c.firstName) || (c === null || c === void 0 ? void 0 : c.lastName)) && !byName.has(nameKey))
                byName.set(nameKey, c);
        });
        var teamMap = new Map();
        (Array.isArray(groups) ? groups : []).forEach(function (group) {
            var groupName = (group === null || group === void 0 ? void 0 : group.group_name) || "Team";
            var members = Array.isArray(group === null || group === void 0 ? void 0 : group.members) ? group.members : [];
            members.forEach(function (member) {
                var rawId = (member === null || member === void 0 ? void 0 : member.unique_ID) ||
                    (member === null || member === void 0 ? void 0 : member.subaccountnumber) ||
                    (member === null || member === void 0 ? void 0 : member.subAccountNumber) ||
                    (member === null || member === void 0 ? void 0 : member.providerID) ||
                    (member === null || member === void 0 ? void 0 : member.providerid) ||
                    (member === null || member === void 0 ? void 0 : member.id) ||
                    ((member === null || member === void 0 ? void 0 : member.email) ? String(member.email).trim().toLowerCase() : "") ||
                    null;
                var fullName = ((member === null || member === void 0 ? void 0 : member.name) || "".concat((member === null || member === void 0 ? void 0 : member.firstname) || "", " ").concat((member === null || member === void 0 ? void 0 : member.lastname) || "")).trim() ||
                    "Unknown";
                var parts = fullName.split(/\s+/).filter(Boolean);
                var firstName = parts.slice(0, -1).join(" ") || parts[0] || "";
                var lastName = parts.length > 1 ? parts[parts.length - 1] : "";
                var email = (member === null || member === void 0 ? void 0 : member.email) || "";
                var emailKey = String(email || "").trim().toLowerCase();
                var nameKey = "".concat(String(firstName || "").trim().toLowerCase(), "|").concat(String(lastName || "").trim().toLowerCase());
                var id = String(rawId || (nameKey && nameKey !== "|" ? nameKey : "".concat(firstName, "-").concat(lastName, "-").concat(emailKey || "member")));
                var existing = teamMap.get(id);
                var legacy = (emailKey && byEmail.get(emailKey)) || byName.get(nameKey) || {};
                var subKey = String((member === null || member === void 0 ? void 0 : member.unique_ID) ||
                    (member === null || member === void 0 ? void 0 : member.subaccountnumber) ||
                    (member === null || member === void 0 ? void 0 : member.subAccountNumber) ||
                    (member === null || member === void 0 ? void 0 : member.providerID) ||
                    (member === null || member === void 0 ? void 0 : member.providerid) ||
                    (member === null || member === void 0 ? void 0 : member.id) ||
                    "").trim();
                var providerFromDirectory = ((providerDirectory === null || providerDirectory === void 0 ? void 0 : providerDirectory.bySub) && subKey && providerDirectory.bySub.get(subKey)) ||
                    ((providerDirectory === null || providerDirectory === void 0 ? void 0 : providerDirectory.byEmail) && emailKey && providerDirectory.byEmail.get(emailKey)) ||
                    null;
                var nurseFromDirectory = ((nurseDirectory === null || nurseDirectory === void 0 ? void 0 : nurseDirectory.bySub) && subKey && nurseDirectory.bySub.get(subKey)) ||
                    ((nurseDirectory === null || nurseDirectory === void 0 ? void 0 : nurseDirectory.byEmail) && emailKey && nurseDirectory.byEmail.get(emailKey)) ||
                    null;
                var alliedFromDirectory = ((alliedDirectory === null || alliedDirectory === void 0 ? void 0 : alliedDirectory.bySub) && subKey && alliedDirectory.bySub.get(subKey)) ||
                    ((alliedDirectory === null || alliedDirectory === void 0 ? void 0 : alliedDirectory.byEmail) && emailKey && alliedDirectory.byEmail.get(emailKey)) ||
                    null;
                // Prefer nurse record if it has nurseid (so nurse template is used).
                var directory = (nurseFromDirectory && (nurseFromDirectory.nurseid || nurseFromDirectory.licensetype) ? nurseFromDirectory : null) ||
                    providerFromDirectory ||
                    alliedFromDirectory ||
                    nurseFromDirectory ||
                    {};
                var isNurse = !!(nurseFromDirectory && !providerFromDirectory);
                if (!existing) {
                    teamMap.set(id, __assign(__assign(__assign(__assign(__assign({}, legacy), directory), { // provider/nurse fields (addr1/tel/fax/...)
                        id: id, firstName: firstName, lastName: lastName, firstname: directory.firstname || legacy.firstname || legacy.firstName || firstName, lastname: directory.lastname || legacy.lastname || legacy.lastName || lastName, email: directory.email || email, status: legacy.status || "active", npinumber: directory.npinumber || legacy.npinumber || legacy.npi || (member === null || member === void 0 ? void 0 : member.npinumber) || (member === null || member === void 0 ? void 0 : member.npi) || (member === null || member === void 0 ? void 0 : member.provider_npi) || "", addr1: directory.addr1 || legacy.addr1 || legacy.address1 || (member === null || member === void 0 ? void 0 : member.addr1) || (member === null || member === void 0 ? void 0 : member.address1) || (member === null || member === void 0 ? void 0 : member.address) || "", addr2: directory.addr2 || legacy.addr2 || legacy.address2 || (member === null || member === void 0 ? void 0 : member.addr2) || (member === null || member === void 0 ? void 0 : member.address2) || "", city: directory.city || legacy.city || (member === null || member === void 0 ? void 0 : member.city) || "", state: directory.state || legacy.state || (member === null || member === void 0 ? void 0 : member.state) || "", postalcode: directory.postalcode || legacy.postalcode || legacy.zip || (member === null || member === void 0 ? void 0 : member.postalcode) || (member === null || member === void 0 ? void 0 : member.zip) || "", tel: directory.tel || legacy.tel || legacy.primaryPhone || (member === null || member === void 0 ? void 0 : member.tel) || (member === null || member === void 0 ? void 0 : member.phone) || (member === null || member === void 0 ? void 0 : member.primaryPhone) || "", cell: directory.cell || legacy.cell || (member === null || member === void 0 ? void 0 : member.cell) || "", fax: directory.fax || legacy.fax || (member === null || member === void 0 ? void 0 : member.fax) || "", nurseid: directory.nurseid || directory.nurseId || legacy.nurseid || legacy.nurseId || "", licensetype: directory.licensetype || directory.licenseType || legacy.licensetype || legacy.licenseType || "", licensenum: directory.licensenum || directory.licenseNum || legacy.licensenum || legacy.licenseNum || "", licenseexpdate: directory.licenseexpdate || directory.licenseExpDate || legacy.licenseexpdate || legacy.licenseExpDate || "", address: directory.address || directory.addr1 || legacy.address1 || (member === null || member === void 0 ? void 0 : member.address) || "", primaryphone: directory.primaryphone || directory.primaryPhone || legacy.primaryPhone || (member === null || member === void 0 ? void 0 : member.phone) || "" }), (isNurse
                        ? {
                            addr1: directory.address || directory.addr1 || "",
                            tel: directory.primaryphone || directory.primaryPhone || "",
                        }
                        : {})), { address1: legacy.address1 || (member === null || member === void 0 ? void 0 : member.address1) || (member === null || member === void 0 ? void 0 : member.address) || "", address2: legacy.address2 || (member === null || member === void 0 ? void 0 : member.address2) || "", zip: legacy.zip || (member === null || member === void 0 ? void 0 : member.zip) || "", primaryPhone: legacy.primaryPhone || (member === null || member === void 0 ? void 0 : member.phone) || (member === null || member === void 0 ? void 0 : member.primaryPhone) || "", secondaryPhone: legacy.secondaryPhone || "", groupName: groupName, _groups: new Set([groupName]), providerid: String((!isNurse
                            ? directory.providerid ||
                                directory.subaccountnumber ||
                                directory.subAccountNumber ||
                                (member === null || member === void 0 ? void 0 : member.providerid) ||
                                subKey
                            : directory.providerid || (member === null || member === void 0 ? void 0 : member.providerid) || "") || "").trim() || (!isNurse ? id : ""), member_unique_ID: String(subKey ||
                            (member === null || member === void 0 ? void 0 : member.unique_ID) ||
                            (member === null || member === void 0 ? void 0 : member.subaccountnumber) ||
                            (member === null || member === void 0 ? void 0 : member.subAccountNumber) ||
                            (member === null || member === void 0 ? void 0 : member.providerID) ||
                            (member === null || member === void 0 ? void 0 : member.providerid) ||
                            (member === null || member === void 0 ? void 0 : member.id) ||
                            rawId ||
                            "").trim() }));
                }
                else {
                    existing._groups.add(groupName);
                }
            });
        });
        return Array.from(teamMap.values())
            .map(function (m) { return (__assign(__assign({}, m), { groupName: Array.from(m._groups).join(", ") })); })
            .sort(function (a, b) {
            var an = "".concat(a.firstName || "", " ").concat(a.lastName || "").trim().toLowerCase();
            var bn = "".concat(b.firstName || "", " ").concat(b.lastName || "").trim().toLowerCase();
            return an.localeCompare(bn);
        });
    }
    function mergeAssignedProviders(teamContacts, strictlyAssignedProviders, providerDirectory) {
        var contacts = Array.isArray(teamContacts) ? __spreadArray([], teamContacts, true) : [];
        var existingIds = new Set(contacts.map(function (c) { return String(c.id || "").trim(); }).filter(Boolean));
        var existingEmails = new Set(contacts.map(function (c) { return String(c.email || "").trim().toLowerCase(); }).filter(Boolean));
        var providerList = Array.isArray(strictlyAssignedProviders) ? strictlyAssignedProviders : [];
        var directoryById = new Map((Array.isArray(providerDirectory === null || providerDirectory === void 0 ? void 0 : providerDirectory.list) ? providerDirectory.list : []).map(function (p) { return [
            String((p === null || p === void 0 ? void 0 : p.subaccountnumber) || (p === null || p === void 0 ? void 0 : p.subAccountNumber) || (p === null || p === void 0 ? void 0 : p.providerid) || (p === null || p === void 0 ? void 0 : p.npinumber) || "").trim(),
            p,
        ]; }));
        providerList.forEach(function (p) {
            var id = String((p === null || p === void 0 ? void 0 : p.subaccountnumber) || (p === null || p === void 0 ? void 0 : p.subAccountNumber) || (p === null || p === void 0 ? void 0 : p.providerid) || (p === null || p === void 0 ? void 0 : p.npinumber) || "").trim();
            var email = String((p === null || p === void 0 ? void 0 : p.email) || "").trim().toLowerCase();
            if ((id && existingIds.has(id)) || (email && existingEmails.has(email))) {
                return;
            }
            var enriched = (id && directoryById.get(id)) || p;
            contacts.push(__assign(__assign({}, enriched), { id: id || email || "".concat((enriched === null || enriched === void 0 ? void 0 : enriched.firstname) || "", "-").concat((enriched === null || enriched === void 0 ? void 0 : enriched.lastname) || ""), member_unique_ID: String((enriched === null || enriched === void 0 ? void 0 : enriched.providerid) ||
                    (enriched === null || enriched === void 0 ? void 0 : enriched.subaccountnumber) ||
                    (enriched === null || enriched === void 0 ? void 0 : enriched.subAccountNumber) ||
                    id ||
                    "").trim(), firstname: (enriched === null || enriched === void 0 ? void 0 : enriched.firstname) || "", lastname: (enriched === null || enriched === void 0 ? void 0 : enriched.lastname) || "", email: (enriched === null || enriched === void 0 ? void 0 : enriched.email) || "", npinumber: (enriched === null || enriched === void 0 ? void 0 : enriched.npinumber) || "", addr1: (enriched === null || enriched === void 0 ? void 0 : enriched.addr1) || "", addr2: (enriched === null || enriched === void 0 ? void 0 : enriched.addr2) || "", city: (enriched === null || enriched === void 0 ? void 0 : enriched.city) || "", state: (enriched === null || enriched === void 0 ? void 0 : enriched.state) || "", postalcode: (enriched === null || enriched === void 0 ? void 0 : enriched.postalcode) || "", tel: (enriched === null || enriched === void 0 ? void 0 : enriched.tel) || "", cell: (enriched === null || enriched === void 0 ? void 0 : enriched.cell) || "", fax: (enriched === null || enriched === void 0 ? void 0 : enriched.fax) || "", status: "active", groupName: "Assigned Provider", _groups: new Set(["Assigned Provider"]) }));
            if (id)
                existingIds.add(id);
            if (email)
                existingEmails.add(email);
        });
        return contacts.sort(function (a, b) {
            var an = "".concat(a.firstname || a.firstName || "", " ").concat(a.lastname || a.lastName || "").trim().toLowerCase();
            var bn = "".concat(b.firstname || b.firstName || "", " ").concat(b.lastname || b.lastName || "").trim().toLowerCase();
            return an.localeCompare(bn);
        });
    }
    /** Maps a raw flattened team member (firstname/addr1/tel/cell/... shaped,
     * matching what CurrentProviderBio historically expected) into the
     * TeamMember shape TeamCard.vue (modeled on ProviderCard.vue) expects. */
    function mapToTeamMember(m) {
        var firstName = m.firstname || m.firstName || "";
        var lastName = m.lastname || m.lastName || "";
        return {
            id: String(m.id || m.member_unique_ID || ""),
            providerid: String(m.providerid || m.member_unique_ID || ""),
            accountnumber: staffContext.value.externId2,
            subaccountnumber: String(m.member_unique_ID || ""),
            firstName: firstName,
            lastName: lastName,
            dateOfBirth: m.dob || "",
            socnum: m.socialnum || "",
            phone: m.tel || m.primaryphone || m.primaryPhone || "",
            mobile: m.cell || "",
            email: m.email || "",
            address: {
                street: m.addr1 || m.address1 || "",
                street2: m.addr2 || m.address2 || "",
                city: m.city || "",
                state: m.state || "",
                zip: m.postalcode || m.zip || "",
            },
            npinumber: m.npinumber || "",
            licenseNumber: m.licensenum || m.certificatenumber || m.licenseNumber || "",
            fax: m.fax || "",
            arn: m.groupName || "Team",
            providerStatus: m.status || "Active",
            avatarColor: generateAvatarColor("".concat(firstName, " ").concat(lastName)),
            tags: [],
            status: m.status || "active",
            taxonomy: m.licensetype || "",
            onTeam: 1,
            lastVisit: m.lastVisit,
            nextVisit: m.nextVisit,
            member_unique_ID: String(m.member_unique_ID || ""),
        };
    }
    /** Orchestrates the full "My Team" load: legacy contacts + provider/nurse
     * directories + patient-owned messaging groups, flattened and deduped into
     * one list, then mapped into card-ready TeamMember objects. */
    function loadMyTeam() {
        return __awaiter(this, void 0, void 0, function () {
            var ctx, patientId, accountNumber, legacyContacts, allContacts, _a, providerDirectory, nurseDirectory, alliedDirectory, strictlyAssignedProviders, content, response, payload, groups, teamContacts, merged, e_5;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        ctx = staffContext.value;
                        patientId = (_c = (_b = allData.value) === null || _b === void 0 ? void 0 : _b.patient) === null || _c === void 0 ? void 0 : _c.externId;
                        accountNumber = ctx.externId2 || ((_e = (_d = allData.value) === null || _d === void 0 ? void 0 : _d.patient) === null || _e === void 0 ? void 0 : _e.externId2);
                        if (!patientId || !accountNumber) {
                            rawTeam.value = [];
                            patteam.value = [];
                            return [2 /*return*/];
                        }
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, (0, userApi_1.getContacts)().catch(function () { return []; })];
                    case 2:
                        legacyContacts = _f.sent();
                        allContacts = Array.isArray(legacyContacts) ? legacyContacts : [];
                        return [4 /*yield*/, Promise.all([
                                fetchProviderDirectory(patientId, accountNumber),
                                fetchNurseDirectory(accountNumber, patientId),
                                fetchAlliedDirectory(accountNumber),
                                fetchStrictlyAssignedProviders(accountNumber, patientId),
                            ])];
                    case 3:
                        _a = _f.sent(), providerDirectory = _a[0], nurseDirectory = _a[1], alliedDirectory = _a[2], strictlyAssignedProviders = _a[3];
                        content = {
                            Messages: {
                                API_Meth: "GetPatientTeamForMessaging",
                                accountnumber: accountNumber,
                                patient_unique_ID: patientId,
                            },
                        };
                        return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })];
                    case 4:
                        response = _f.sent();
                        payload = normalizeApiPayload(response.data);
                        groups = payload && String(payload.status || "").toLowerCase().includes("success")
                            ? (Array.isArray(payload.data) ? payload.data : [])
                            : [];
                        teamContacts = flattenTeamMembers(groups, allContacts, providerDirectory, nurseDirectory, alliedDirectory);
                        merged = mergeAssignedProviders(teamContacts, strictlyAssignedProviders, providerDirectory);
                        rawTeam.value = merged;
                        patteam.value = merged.map(mapToTeamMember);
                        // Modals (Call/Email/SMS) send "from" the current logged-in identity.
                        try {
                            currentProvider.value = (0, messagingSender_1.messagingSender)(allData.value);
                        }
                        catch (mapErr) {
                            console.warn("Could not derive currentProvider identity:", mapErr);
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_5 = _f.sent();
                        console.error("Failed to load patient team for messaging:", e_5);
                        rawTeam.value = [];
                        patteam.value = [];
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    return {
        currentProvider: currentProvider,
        patteam: patteam,
        rawTeam: rawTeam,
        searchQuery: searchQuery,
        filterTag: filterTag,
        sortBy: sortBy,
        allTags: allTags,
        filteredProviders: filteredProviders,
        updateProviders: updateProviders,
        getProviderById: getProviderById,
        setSearchQuery: setSearchQuery,
        setFilterTag: setFilterTag,
        setSortBy: setSortBy,
        loadMyTeam: loadMyTeam,
        axiosUpdateTeam: axiosUpdateTeam
    };
});
